import { NextSeo } from 'next-seo';
import Image from 'next/image';
import Link from 'next/link';
import Button from '../elements/Button';
import RichText from '../elements/RichText';
import Container from './Container';

interface ErrorProps {
    statusCode: number;
}

const statusCodes: { [code: number]: string } = {
    400: 'Bad Request',
    404: 'Page Not Found',
    405: 'Method Not Allowed',
    500: 'Internal Server Error',
};

const Error = ({ statusCode }: ErrorProps) => {
    const pageTitle = statusCodes[statusCode] || 'An Unexpected Error Has Occurred';

    return (
        <>
            <NextSeo title={pageTitle} />
            <Container>
                <div className="h-[90vh] flex flex-col items-center justify-center pt-20 gap-8 text-primary">
                    <Image src="/primary-logo.svg" alt="Star RV Logo" width={150} height={100} />
                    <h1 className="h2 primary">{pageTitle}</h1>
                    <RichText className="text-center" content="Looks like you took a wrong turn and ended up off the beaten path. Sorry about that." />
                    <Button variant="fill">
                        <Link className="m-2 hover:animate-pulse" href="/" prefetch={false}>
                            Return to Home
                        </Link>
                    </Button>
                </div>
            </Container>
        </>
    );
};

export default Error;
